import { container } from 'tsyringe'
import Vue from 'vue'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import { ChangePasswordApiRequest } from '@/data/payload/api/AuthRequest'
import store from '@/app/ui/store'
import { SettingPresenter } from '../presenters/SettingPresenter'
import {
  EventBus,
  EventBusConstants,
} from '@/app/infrastructures/misc'

export interface SettingState {
  isLoading: boolean
}

@Module({ namespaced: true, store, name: 'settings', dynamic: true })
class SettingController extends VuexModule implements SettingState {
  private presenter: SettingPresenter = container.resolve(SettingPresenter)
  public isLoading = false

  @Action({ rawError: true })
  public changePassword(form: {
    currentPass: string
    newPass: string
    confirmPass: string
    token: string
  }) {
    this.setLoading(true)

    this.presenter
      .changePassword(
        new ChangePasswordApiRequest(
          form.currentPass,
          form.newPass,
          form.confirmPass,
          form.token
        )
      )
      .then(res => {
        EventBus.$emit(EventBusConstants.CHANGE_PASSWORD_SUCCESS, {})
      })
      .catch(error => {
        Vue.notify({
          title: 'Change Password Failed',
          text:
            error.status === 400 || error.status === 422
              ? error.error.message.en
              : 'Something wrong',
          type: 'error',
          duration: 5000,
        })
        EventBus.$emit(EventBusConstants.CHANGE_PASSWORD_ERROR, !(error.status === 400 && error.data.error_id === 3))
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Mutation
  private setLoading(bool: boolean) {
    this.isLoading = bool
  }
}

export default getModule(SettingController)
